import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import axios from "axios";


export function getProductBrands(
  from = 0,
  size = 10000,
  status = "all",
  searchText = ""
) {
  return async (dispatch, getState) => {
    try {
         const token = getState().user.uat;

      // Build params dynamically
      const params = {
        from: from,
        size: size,
      };

      if (searchText !== "") {
        params.searchText = searchText;
      }

      if (status && status !== "all") {
        params.status = status;
      }

      const response = await axios.get(
        constants.API_URL + "/catalog/brands",
        {
          headers: {
            Authorization: "Bearer " + token,
          },
          params: params,
        }
      );

      let productBrands = [];
      let totalCount = 0;

      if (
        response &&
        response.hasOwnProperty("data") &&
        response.data.hasOwnProperty("code") &&
        response.data.code === "0"
      ) {
        if (response.data.hasOwnProperty("productBrands")) {
          productBrands = response.data.productBrands;
        }

        if (
          response.data.hasOwnProperty("pagination") &&
          response.data.pagination.hasOwnProperty("totalCount")
        ) {
          totalCount = response.data.pagination.totalCount;
        }
      } else {
        if (
          response &&
          response.hasOwnProperty("data") &&
          response.data.hasOwnProperty("message")
        ) {
          alert(response.data.message);
        } else {
          alert("Failed to load data");
        }
      }

       dispatch({
        type: actionTypes.PRODUCT_BRANDS_GET,
        productBrands:productBrands,
      });

      return {
        searchResult: productBrands,
        totalCount: totalCount,
      };
    } catch (error) {
      console.error("Error fetching product brands", error);

      if (
        error &&
        error.hasOwnProperty("response") &&
        error.response.hasOwnProperty("data") &&
        error.response.data.hasOwnProperty("message")
      ) {
        alert(error.response.data.message);
      } else {
        alert("Something went wrong while fetching brands");
      }

      return {
        searchResult: [],
        totalCount: 0,
      };
    }
  };
}

// export function getProductBrands() {
//   return async (dispatch, getState) => {
//     try {
//       const token = getState().user.uat;
//       const response = await axios.get(constants.API_URL + "/catalog/brands", {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const productBrands = (response.data.productBrands || []).map(
//         (brand) => ({
//           key: brand.key || brand.id,
//           ...brand,
//         })
//       );

//       dispatch({
//         type: actionTypes.PRODUCT_BRANDS_GET,
//         productBrands,
//       });

//       return productBrands;
//     } catch (error) {
//       return [];
//     }
//   };
// }

export function deleteProductBrand(key) {
  return async (dispatch, getState) => {
    const user = getState().user.user;

    try {
      const token = getState().user.uat;
      const response = await axios.delete(
        constants.API_URL + "/catalog/brands/" + key,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return true;
    } catch (error) {
      return false;
    }
  };
}

export function saveProductBrand(productBrand, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const payload = {
        ...productBrand,
      };
      // =========================
      // 🔹 UPDATE BRAND
      // =========================
      if (key && key.trim() !== "") {
        const response = await axios.put(
          `${constants.API_URL}/catalog/brands/${key}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        response.data.message = "Brand saved successfully";
        return response.data;
      } else {
        // =========================
        // 🔹 CREATE BRAND
        // =========================
        const response = await axios.post(
          `${constants.API_URL}/catalog/brands`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        response.data.message = "Brand saved successfully";
        return response.data;
      }
    } catch (error) {
      return {
        code: "1",
        message: "Error saving brand. Please try again.",
        brand: null,
      };
    }
  };
}
